<script setup lang="ts">
import { ref } from 'vue'
import { downloadXlsx } from '@/utils/downloadXlsx'

const props = defineProps<{
  path: string
  params: Record<string, unknown>
  filename: string
}>()

const busy = ref(false)

async function onClick() {
  if (busy.value) return
  busy.value = true
  try {
    await downloadXlsx(props.path, props.params, props.filename)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <button type="button" class="export-btn" :disabled="busy" @click="onClick">
    {{ busy ? 'Экспорт…' : 'Экспорт в Excel' }}
  </button>
</template>

<style scoped>
.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-2);
  border-radius: var(--r-ctrl);
  font-size: var(--fs-sm);
  cursor: pointer;
}
.export-btn:hover:not(:disabled) { background: var(--bg-2); color: var(--ink); }
.export-btn:disabled { opacity: 0.6; cursor: default; }
</style>
